(() => {
  const map = window.CKB_PRODUCT_LEARNING_MAP;
  if (!map || !Array.isArray(map.profiles)) return;
  if (map.profiles.some(profile => profile.name === 'CHA SKYLOOP 40')) return;
  map.profiles.push({
    name: 'CHA SKYLOOP 40',
    aliases: ['skyloop 40', 'cha skyloop 40'],
    status: 'active',
    builderSupported: false,
    matchingArticleCount: 4,
    articles: [
      {
        id: 'CKC-KA-1396',
        title: 'CHA SKYLOOP 40 Product DNA and Operating Scope',
        handle: 'cha-skyloop-40-product-dna',
        quick: 'Understand the 141 ft horizontal full-wave loop, supported bands, power limits, footprint, height, and operating roles.',
        category: 'Product Installation Guides',
        section: 'CHA SKYLOOP 40',
        role: 'Product DNA / Overview',
        url: '/pages/chameleon-knowledge-base?article=cha-skyloop-40-product-dna'
      },
      {
        id: 'CKC-KA-1397',
        title: 'CHA SKYLOOP 40 Installation and Support Planning',
        handle: 'cha-skyloop-40-installation-and-support-planning',
        quick: 'Plan four safe supports, preserve the 141 ft loop length, protect the feedpoint, and verify the final geometry.',
        category: 'Product Installation Guides',
        section: 'CHA SKYLOOP 40',
        role: 'Installation / Deployment',
        url: '/pages/chameleon-knowledge-base?article=cha-skyloop-40-installation-and-support-planning'
      },
      {
        id: 'CKC-KA-1398',
        title: 'CHA SKYLOOP 40 Tuning, SWR, and Troubleshooting',
        handle: 'cha-skyloop-40-tuning-swr-and-troubleshooting',
        quick: 'Use the official 40 m band-edge decision rule, trim carefully, and diagnose feed-line or connection faults before changing wire length.',
        category: 'Maintenance & Repair',
        section: 'CHA SKYLOOP 40',
        role: 'Troubleshooting / Maintenance',
        url: '/pages/chameleon-knowledge-base?article=cha-skyloop-40-tuning-swr-and-troubleshooting'
      },
      {
        id: 'CKC-KA-0122',
        title: 'What Is a Horizontal Loop Antenna?',
        handle: 'what-is-a-horizontal-loop-antenna',
        quick: 'Learn how horizontal loops work and why height, circumference, geometry, and the completed feed system matter.',
        category: 'Getting Started',
        section: 'Antenna Types',
        role: 'Engineering / Selection',
        url: '/pages/chameleon-knowledge-base?article=what-is-a-horizontal-loop-antenna'
      }
    ]
  });
})();
